import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import ReactCrop from 'react-image-crop';
import image64toCanvasRef from '../../shared/image-utils';

function getCrop(aspect, originalWidth, originalHeight) {
  let x = 0;
  let y = 0;
  let width = originalWidth;
  let height = originalHeight;

  if (originalWidth / originalHeight < aspect) {
    height = width / aspect;
    y = (originalHeight - height) / 2;
  } else {
    width = height * aspect;
    x = (originalWidth - width) / 2;
  }

  return {
    x, y, width, height,
  };
}

function getCanvasBlob(canvas) {
  const blobBin = atob(canvas.toDataURL().split(',')[1]);
  const array = _.map(blobBin, (d, i) => blobBin.charCodeAt(i));
  return new Blob([new Uint8Array(array)], { type: 'image/png' });
}

export default class AutoCropImagePreview extends React.Component {
  static propTypes = {
    source: PropTypes.string,
    aspect: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  };

  static defaultProps = {
    source: null,
  };

  constructor(props) {
    super(props);

    this.imagePreviewCanvasRef = React.createRef();

    this.handleImageLoaded = this.handleImageLoaded.bind(this);
  }

  handleImageLoaded(image) {
    const canvasRef = this.imagePreviewCanvasRef.current;

    if (canvasRef) {
      const { width, aspect, source } = this.props;
      const height = width / aspect;
      const { naturalWidth, naturalHeight } = image;
      this.imageRef = image;

      image64toCanvasRef(
        canvasRef,
        source,
        getCrop(aspect, naturalWidth, naturalHeight),
        { width, height },
      );
    }
  }

  async getOriginalCanvasBlob() {
    let canvas = document.createElement('canvas');
    const { aspect, source } = this.props;
    const { naturalWidth, naturalHeight } = this.imageRef;
    const crop = getCrop(aspect, naturalWidth, naturalHeight);

    await image64toCanvasRef(canvas, source, crop, crop);

    const blob = getCanvasBlob(canvas);
    canvas = null;
    return blob;
  }

  render() {
    const { aspect, source } = this.props;

    return (
      <React.Fragment>
        {source
          ? (
            <div>
              <ReactCrop
                style={{ display: 'none' }}
                src={source}
                crop={{ aspect }}
                onImageLoaded={this.handleImageLoaded}
                onComplete={() => {}}
                onChange={() => {}}
              />

              <canvas ref={this.imagePreviewCanvasRef} />
            </div>
          )
          : null}
      </React.Fragment>
    );
  }
}
